// Mirrors parceldaily-api constants/bannerPlacement.ts
export const BANNER_PLACEMENT = {
  DASHBOARD_CAROUSEL: "DASHBOARD_CAROUSEL",
  TRACK_PARCEL: "TRACK_PARCEL",
};

export const BANNER_PLACEMENT_LABEL = {
  [BANNER_PLACEMENT.DASHBOARD_CAROUSEL]: "Dashboard Carousel",
  [BANNER_PLACEMENT.TRACK_PARCEL]: "Track Parcel",
};
